import axios from "axios";
import env from "../env";

const api_url = env.API_URL;

export const getAllInstructors = async (token: string) => {
    try {
        const response = await axios.get(`${api_url}admin/get-instructors`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getInstructorById = async (instructorId: string, token: string) => {
    try {
        const response = await axios.get(`${api_url}admin/get-instructor-by-id?Id=${instructorId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getInstructors = async (programme: string, stream: string, subject: string, token: string) => {
    try {
        const response = await axios.get(`${api_url}instructors`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: {
                programme,
                stream,
                subject
            }
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const getSubmissions = async (programme: string, stream: string, subject: string, assignmentMaterialId:any, token: string) => {
    try {
        const response = await axios.get(`${api_url}assignments/subject-combination-users`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
            responseType: "json",
            params: {
                programme,
                stream,
                subject,
                assignmentMaterialId
            }
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const updateMarks = async (body:any, token:any) => {
    try {
        const response = await axios.put(`${api_url}assignments/marks`, body, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteInstructor = async (token: string, id: any) => {
    try {
        const response = await axios.delete(`${api_url}admin/delete-instructor?Id=${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}